import React from 'react'
import { useParams } from 'react-router-dom'
import ProjectTabBar from './ProjectTabBar'

const ProjectLayout = ({ children }) => {
  const { id } = useParams()

  return (
    <div className="flex flex-col -mt-4 lg:-mt-6 -mx-4 lg:-mx-6">
      <ProjectTabBar projectId={id} />
      <div className="p-4 lg:p-6">
        {children}
      </div>
    </div>
  )
}

export default ProjectLayout
